module.exports = "<div>\n  <div class=\"{{ cssClass() }} alert-dismissable p-3\">\n    {{data.message}}\n  </div>\n</div>\n\n\n"